import { useEffect, useState } from "react"
import BookingForm from "../../components/bookingForm/BookingForm"
import CartesExplain from "../../components/cartesExplain/CartesExplain";
import { IDataCartes } from "../../models/component/carteExplain/datacartes";
import MenuService from "../../services/api/menu.service";
import { useNavigate } from "react-router-dom";

const Cartes = () => {

  const navigate = useNavigate();

  const handleNavigate = (url:string) => {
    navigate(`/cartes/${url}`)
  }

  return (
    <div className="view-cartes">
      <div className="container-title">
        <div className="title">Cartes</div>
      </div>
      <div className="container-cartes">
        <div className="container-choice">
          <div className="carte-left-choice" onClick={()=> handleNavigate("menu")}>
            <img className="img-left-choice" src="/assets/images/menu.jpg" alt="" />
            <div className="choice-title">Menu du restaurant</div>
          </div>
          <div className="carte-left-choice" onClick={()=> handleNavigate("pizzas")}>
            <img className="img-left-choice" src="/assets/images/pizza.jpg" alt="" />
            <div className="choice-title">Pizza à Emporter</div>
          </div>
        </div>
      </div>
      <BookingForm />
    </div>
  );
};

export default Cartes;


